// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1kjG0","Open":"SideDrawer_Open__1XUZ_","Close":"SideDrawer_Close__3pipb","LogoHeight":"SideDrawer_LogoHeight__1Oflm"};